export * from "./auth.js";
export * from "./severity.js";
export * from "./confidence.js";
export * from "./modules.js";
export * from "./work.js";
export * from "./phone.js";

/** Every API route lives under this prefix. Clients build URLs from it. */
export const API_PREFIX = "/api/v1";

/**
 * Non-functional targets, as machine-readable constants so the instrumentation
 * added in Phase 7 measures against the same numbers the product committed to
 * rather than a re-typed copy.
 */
export const NFR_TARGETS = {
  /** End-to-end technician time for a standard assessment. */
  assessmentSeconds: 90,
  /** Area scan upload → hazard list, online. */
  hazardListSeconds: 15,
  /** PPE verdict, on device. */
  ppeCheckSeconds: 1,
  /** Battery consumed per assessment, as a fraction. */
  batteryPerAssessment: 0.04,
  /** Ladder angle tolerance in degrees, against the 4:1 rule (75.5°). */
  ladderAngleToleranceDeg: 2,
  ladderTargetAngleDeg: 75.5,
} as const;
